"use strict";const t=new Set,n=e=>{t.add(e)},r=e=>t.has(e);export{n as markAsRtlAware,r as isRtlAware};
//# sourceMappingURL=RTLAwareRegistry.js.map
